// extracted by mini-css-extract-plugin
export var createdDate = "_nz-1";
export var divider = "_nz-2";
export var headerDivider = "_nz-3";
export var messagesCard = "_nz-0";
export var messagesContainer = "_nz-7";
export var messagesContainerWrapper = "_nz-4";
export var pointerCapturingButtonBoxes = "_nz-a";
export var showLeftPanelButton = "_nz-9";
export var showMoreButton = "_nz-c";
export var showMoreButtonContainer = "_nz-b";
export var summaryTitle = "_nz-6";
export var systemMessageCardWrapper = "_nz-d";
export var topButtons = "_nz-8";
export var withPadding = "_nz-5";